import { EnvironmentProviders, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { SITE_CONFIG_DATA, SiteConfigData } from './site-config.model';
import { organizationJsonLdInitializerFn } from './organization-jsonld.initializer';

export function provideOrganizationJsonLd(data: SiteConfigData): EnvironmentProviders {
    return makeEnvironmentProviders([
        { provide: SITE_CONFIG_DATA, useValue: data },
        provideAppInitializer(organizationJsonLdInitializerFn),
    ]);
}
